import Button from "@mui/material/Button"
import Dialog from "@mui/material/Dialog"
import DialogActions from "@mui/material/DialogActions"
import DialogContent from "@mui/material/DialogContent"
import Typography from "@mui/material/Typography"
import { useSelector } from "react-redux"

import Column from "../../../common/components/Column"
import { selectAuthorizedEmailProvider } from "../reducer"
import { useConnectEmailDialogRequirements } from "./ConfirmConnectEmailDialog"
import DialogHeader from "./DialogHeader"

export default function RefreshEmailProviderDialog({ open, onClose }) {
  const authorizedEmailProvider = useSelector(selectAuthorizedEmailProvider)
  const { updateProviderConnection } = useConnectEmailDialogRequirements()

  function handleReauthenticateButtonClicked() {
    updateProviderConnection(authorizedEmailProvider)
    onClose()
  }

  function handleSoftClose() {
    onClose()
  }

  return (
    <Dialog open={open} onClose={handleSoftClose} maxWidth="xs" fullWidth>
      <DialogHeader
        title={`Reauthenticate your ${authorizedEmailProvider?.name} Account`}
        onClose={handleSoftClose}
      />
      <DialogContent>
        <Column sx={{ gap: 3 }}>
          <img
            src={authorizedEmailProvider?.icon}
            width="48px"
            style={{ alignSelf: "center" }}
            alt={authorizedEmailProvider?.name}
          />
          <Column sx={{ gap: 2 }}>
            <Typography>
              You need to re-authenticate your{" "}
              <strong>{authorizedEmailProvider?.name}</strong> account.
            </Typography>
            <Typography>
              This will allow our app to synchronize your profile, send and
              receive emails on your behalf and create calendar events.
            </Typography>
            <Typography>This should take only a few seconds.</Typography>
          </Column>
        </Column>
      </DialogContent>
      <DialogActions>
        <Button variant="outlined" color="primary" onClick={handleSoftClose}>
          Cancel
        </Button>
        <Button
          variant="contained"
          color="primary"
          onClick={handleReauthenticateButtonClicked}
        >
          Re-authenticate
        </Button>
      </DialogActions>
    </Dialog>
  )
}
